<template>
  <div>
    <h1 class="settings-title">
      Connect WhatsApp Account
    </h1>
    <!--<button-->
    <!--class="btn btn-main btn-round mb-3"-->
    <!--@click="openTemplateMessageModal()">-->
    <!--Submit New Template Message-->
    <!--</button>-->
    <div class="settings-form">
      Coming soon
    </div>
  </div>
</template>

<script>
export default {
  name: 'WhatsappConnectSettings',
};
</script>
